import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const MobileNav = () => {
  const { userRole } = useAuth();
  const isManager = userRole === 'manager';

  return (
    <nav className="portal-mobile-nav">
      <NavLink to="/" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
        <i className="fa-solid fa-house"></i>
        <span>Home</span>
      </NavLink>
      <NavLink to="/onboarding" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
        <i className="fa-solid fa-list-check"></i>
        <span>Tasks</span>
      </NavLink>
      <NavLink to="/time-off" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
        <i className="fa-solid fa-plane"></i>
        <span>PTO</span>
      </NavLink>
      
      {isManager ? (
        <NavLink to="/manager" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
          <i className="fa-solid fa-users"></i>
          <span>Team</span>
        </NavLink>
      ) : (
        <NavLink to="/documents" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
          <i className="fa-solid fa-file"></i>
          <span>Docs</span>
        </NavLink>
      )}
      <NavLink to="/profile" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
        <i className="fa-solid fa-user"></i>
        <span>Profile</span>
      </NavLink>
    </nav>
  );
};

export default MobileNav;
